/* WAFRA CITY — theme behaviour.
   Deliberately small. One motion idea, a nav drawer, a hero pause control.
   No cart logic exists in this theme while preview mode is on. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* sticky header hairline */
  var hdr = document.querySelector('[data-header]');
  if (hdr && 'IntersectionObserver' in window) {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(probe);
    new IntersectionObserver(function (e) {
      hdr.classList.toggle('is-stuck', !e[0].isIntersecting);
    }).observe(probe);
  }

  /* mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.getElementById('hdr-drawer');
  if (toggle && drawer) {
    window.matchMedia('(min-width: 1100.01px)').addEventListener('change', function (e) {
      if (e.matches) { drawer.removeAttribute('open'); toggle.setAttribute('aria-expanded', 'false'); }
    });
    toggle.addEventListener('click', function () {
      var open = drawer.hasAttribute('open');
      if (open) { drawer.removeAttribute('open'); } else { drawer.setAttribute('open', ''); }
      toggle.setAttribute('aria-expanded', String(!open));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* Hero video activation.
     The <source> ships with data-src, so nothing is fetched until here. A phone
     was downloading 3.1 MB of hero loop it never needed; below 761px the poster
     <img> is the whole hero. Reduced motion also means no download at all —
     pausing an already-fetched video would still have cost the bytes. */
  var vid = document.querySelector('[data-hero-video]');
  var pause = document.querySelector('[data-hero-pause]');
  var wantsVideo = !reduce && window.matchMedia('(min-width: 761px)').matches;

  /* The control's visibility follows the VIDEO's real state, never the
     viewport. A media query would be wrong here: at 900px with reduced motion,
     or after a failed download, the viewport says "desktop" while there is
     nothing to pause. So the button ships hidden and is revealed only once the
     element reports it can actually play, and is re-hidden if playback breaks.

     The earlier attempt set pause.hidden and stopped there. That silently did
     nothing: .hero__pause declares display:grid, and an author display
     declaration beats the user-agent [hidden]{display:none}. The CSS guard
     .hero__pause[hidden] now makes the attribute authoritative. */
  function showPause(on) {
    if (!pause) return;
    pause.hidden = !on;
  }

  if (vid && wantsVideo) {
    var src = vid.querySelector('source[data-src]');
    if (src && !src.src) {
      // Reveal only on a signal that the media is genuinely playable, and
      // withdraw the control on any failure so the poster stands alone.
      vid.addEventListener('canplay', function () { showPause(true); });
      vid.addEventListener('playing', function () { showPause(true); });
      vid.addEventListener('error', function () { showPause(false); });
      vid.addEventListener('emptied', function () { showPause(false); });
      if (src.addEventListener) src.addEventListener('error', function () { showPause(false); });

      src.src = src.getAttribute('data-src');
      vid.load();
      var playAttempt = vid.play();
      if (playAttempt && playAttempt.catch) {
        playAttempt.catch(function () {
          /* Autoplay refused. The clip may still be scrubbable, so keep the
             control only if the element reports enough data; otherwise the
             poster is the hero and there is nothing to control. */
          showPause(vid.readyState >= 2);
        });
      }
    }
  } else {
    showPause(false);   // no source will ever be assigned
  }
  if (vid && pause) {
    if (reduce) { vid.pause(); vid.removeAttribute('autoplay'); }
    pause.addEventListener('click', function () {
      if (vid.paused) { vid.play(); pause.setAttribute('aria-label', pause.dataset.labelPause || 'Pause'); }
      else { vid.pause(); pause.setAttribute('aria-label', pause.dataset.labelPlay || 'Play'); }
    });
  }

  /* Ask WAFRA starters — DISABLED 2026-09-08 by Founder decision.

     This handler is currently inert: no Liquid file emits [data-ask-starter]
     any more, so the selector matches nothing and no listener is attached. It
     is commented out rather than left inert because /pages/ask is a 404, and
     an inert handler is one re-added attribute away from sending customers
     there. Restore it only together with a published /pages/ask.

  document.querySelectorAll('[data-ask-starter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = encodeURIComponent(b.textContent.trim());
      window.location.href = '/pages/ask?q=' + q;
    });
  });
  */

  /* ── Section reveal ──────────────────────────────────────────────
     Order of the guards matters more than the effect. Nothing is hidden
     until we have BOTH IntersectionObserver and the visitor's consent to
     motion; if either is missing the page simply renders, fully readable.
     That is why .reveal-on is added by script rather than sitting in the
     markup — a CSS-first approach would leave content invisible on any
     browser where the script fails.

     The hero is deliberately NOT marked with data-reveal in the first place,
     so the LCP element can never be faded in — that is handled in the markup,
     not here. What this filter adds is the viewport test: any marked section
     already on screen at load renders immediately rather than waiting on an
     observer callback. translateY is 14px — small enough that reserving no
     extra space keeps CLS at zero, since transforms do not affect layout. */
  var revealables = Array.prototype.slice.call(
    document.querySelectorAll('[data-reveal]')
  );
  if (!reduce && 'IntersectionObserver' in window && revealables.length) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var toReveal = revealables.filter(function (el) {
      return el.getBoundingClientRect().top > vh * 0.9; // already visible? leave it
    });
    toReveal.forEach(function (el) { el.classList.add('reveal-on'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);                    // one-shot: no fade-out on scroll-up
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    toReveal.forEach(function (el) { io.observe(el); });

    /* Belt and braces (2026-09-13): a fast flick can let the observer coalesce
       callbacks and leave a section that IS on screen still faded out. On every
       scroll (passive, one rAF at a time) reveal anything whose box is inside the
       viewport, and after 8s reveal whatever is left so nothing can stay hidden.
       Cheap: it only walks the not-yet-revealed list, which shrinks to zero. */
    var pending = toReveal.slice();
    var ticking = false;
    function sweep() {
      ticking = false;
      if (!pending.length) return;
      var h = window.innerHeight || document.documentElement.clientHeight;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < h) { el.classList.add('is-in'); io.unobserve(el); return false; }
        return true;
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(sweep); }
    }, { passive: true });
    window.setTimeout(function () {
      pending.forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); });
      pending = [];
    }, 8000);
  }
})();
